const NsghMapFrom = [
  {
    modelvalue: "",
    title: "年份：",
    inputtype: "select",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 230,
    height: 32,
    disabled: false,
    marginLeft: 10,
    marginTop: 30,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: [],
    event: 'YearChange'
  },
];
export default NsghMapFrom;
